import React, { useState } from "react";
import "./styles/welcome-home.css";
//Assets
import RunnerBorder from "../../assets/images/Running-border.png";
import QuotationMarks from "../../assets/icons/quotation_marks.svg";
//Components
import ProgressBar from "../../components/progressbar/ProgressBar";
import StepsToFollow from "../../components/StepsToFollow/StepsToFollow";
import ReadySetGo from "../../components/ReadySetGo/ReadySetGo";
import ScrollAnimation from "react-animate-on-scroll";
import FormRecomendedPlan from "../../components/FormRecommendedPlan/FormRecomendedPlan";

import { getAllMemberships } from "../../services/rest/membership/membershipService";
import toast from "react-hot-toast";

const WelcomeHome = ({ setLoading }) => {
  const [open, setOpen] = useState(false);
  const [memberships, setMemberships] = useState([]);

  const getMemberships = async () => {
    try {
      setLoading(true);

      const response = await getAllMemberships();
      const filterMembershps = [];
      response.map((membership) => {
        if (membership?.planName !== "Free") {
          if (membership?.planName !== "Prestadores de Servicio")
            filterMembershps.push(membership);
        }
      });
      // console.log("Mebresias filtradas", filterMembershps);
      setMemberships(filterMembershps);
      // console.log(response);
      setLoading(false);
    } catch (error) {
      throw error;
    }
  };

  const handleClickOpen = async () => {
    try {
      await getMemberships();
      setOpen(true);
    } catch (error) {
      setOpen(false);
      setLoading(false);
      toast.error(
        "En este momento no se puede generar su plan. \n Intentelo más tarde"
      );
    }
  };
  return (
    <>
      <div className="container-fluid bg-dark">
        <div className="container-progress">
          <ProgressBar />
        </div>
        <div className="container-fluid welcome-bg d-flex align-items-center">
          <div className="container-text ms-lg-5 ps-lg-5 p-3">
            <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut">
              <h1>
                Bienvenido a{" "}
                <span id="text-radaria" className="">
                  Radaria
                </span>
              </h1>
            </ScrollAnimation>
            <div className="container-btn">
              <div className="divider-linear"></div>
              <ScrollAnimation
                animateIn="animate__bounceInLeft"
                animateOut="animate__bounceInLeft"
              >
                <button
                  type="button"
                  className="btn btn-primary rounded-pill pe-4 ps-4  animate__animated animate__pulse animate__infinite infinite "
                  onClick={handleClickOpen}
                >
                  Diseñar plan
                </button>
                <FormRecomendedPlan
                  open={open}
                  setOpen={setOpen}
                  setLoading={setLoading}
                  memberships={memberships ?? []}
                />
              </ScrollAnimation>
            </div>
            <p className="mt-3">
              Fomentamos un entorno que inspira y motiva a los corredores a
              lograr sus objetivos y superar su límites.
            </p>
          </div>
        </div>
        <div className="container mt-5 mb-5">
          <div className="row d-flex align-items-center">
            <div className="mx-auto container-img d-flex justify-content-center  col-lg-5 col-md-6">
              <ScrollAnimation
                animateIn="animate__bounceInLeft"
                animateOut="animate__bounceOutLeft"
              >
                <img
                  className="mx-auto d-block"
                  src={RunnerBorder}
                  alt="Runner Radaria"
                />
              </ScrollAnimation>
            </div>
            <div className="col-lg-7 col-md-6 container-parOfRadaria">
              <ScrollAnimation animateIn="fadeIn" animateOut="fadeOut">
                <h2 className="d-flex justify-content-center text-info">
                  ¡Se parte de
                  <b className="ms-1 text-primary"> Radaria</b>!
                </h2>
              </ScrollAnimation>
              <div className="d-flex">
                <img src={QuotationMarks} alt="quotation-marks" />
                <p className="text-info fs-4">
                  Transforma tu pasión por correr con nuestro soporte integral:
                  rutas, nutrición, fisioterapia y comunidad.
                </p>
              </div>
              <StepsToFollow />
              <div className=" container-readySetGo mt-4">
                <ReadySetGo />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default WelcomeHome;
